module.exports = __webpack_public_path__ + "img/slack.3fd278f8.svg";